<template>
    <div class="relative inline-block text-left">
        <Keypress key-event="keyup" :key-code="27" @success="close" />
        <div>
            <span class="rounded-md shadow-sm">
                <button
                    @click="open = !open"
                    type="button"
                    class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-800 text-sm leading-5 font-medium text-white hover:text-gray-100 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-800 active:text-white transition ease-in-out duration-150"
                    id="options-menu"
                    aria-haspopup="true"
                    aria-expanded="true"
                >
                    {{ selected.name }}
                    <svg
                        class="-mr-1 ml-2 h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </button>
            </span>
        </div>
        <transition name="dropdown">
            <div
                v-show="open"
                class="origin-top-right absolute right-0 bottom-12 mt-2 w-56 rounded-md shadow-lg"
            >
                <div class="rounded-md bg-white ring-1 ring-black ring-opacity-5">
                    <div
                        class="py-1"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                    >
                        <a
                            @click.prevent="() => setCluster(cluster)"
                            v-for="cluster in clusters"
                            :key="`cluster-${cluster.id}`"
                            href="#"
                            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                        >
                            {{ cluster.name }}
                        </a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "ClusterSwitcher",
    components: {
      Keypress: () => import('vue-keypress')
    },
    props: {
        clusters: Array,
        current: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        async setCluster(cluster) {
            const { data } = await axios
                .post(this.route("cluster.switch", { cluster: cluster.id }))
                .catch((error) => console.error(error || error));
            if (data.success) this.redirectRaw("/home/");
        },
        close(){
            this.open = false;
        }
    },
    computed: {
        selected() {
            const clusters = this.clusters.filter((cluster) => {
                return cluster.id === this.current;
            });
            if (clusters.length) return clusters[0];
            else return this.clusters[0];
        },
    },
};
</script>

